/* eslint-disable no-template-curly-in-string */
import { defineMessages } from 'react-intl';

export default defineMessages({
  allowedExtensions: {
    id: 'formblock_file_allowed_extensions',
    defaultMessage: 'Allowed file extensions: {extensions}.',
  },
  maxFileSize: {
    id: 'formblock_file_max_size',
    defaultMessage: 'Maximum allowed file size: {size} MB.',
  },
  invalidExtension: {
    id: 'formblock_file_invalid_extension',
    defaultMessage: 'Invalid extension. Allowed extensions: {extensions}.',
  },
  fileTooLarge: {
    id: 'formblock_file_too_large',
    defaultMessage: 'Files larger than {size} MB are not allowed.',
  },
  default_to_description: {
    id: 'form_to_description',
    defaultMessage:
      'Email address(es) to which the form data will be sent. Separate multiple addresses with commas.',
  },
  numberMinValueMessage: {
    id: 'formblock_numberMinValueMessage',
    defaultMessage: 'The value must be greater than or equal to {min}.',
  },
  numberMaxValueMessage: {
    id: 'formblock_numberMaxValueMessage',
    defaultMessage: 'The value must be less than or equal to {max}.',
  },
});
